var map = {
	"./AuthorDashboard/CourseListingGrid.vue": 758,
	"./AuthorDashboard/ManageAdmins.vue": 759,
	"./AuthorDashboard/ManageAuthors.vue": 765,
	"./AuthorDashboard/ManageBlockedEmailDomainsGrid.vue": 766,
	"./AuthorDashboard/ManageCourse.vue": 769,
	"./AuthorDashboard/ManageGradeLevelsGrid.vue": 785,
	"./AuthorDashboard/ManageInstitutionsGrid.vue": 790,
	"./AuthorDashboard/ManagePeerReviewers.vue": 791,
	"./AuthorDashboard/ManageProgramsGrid.vue": 792,
	"./AuthorDashboard/ManageRegistrantAccess.vue": 798,
	"./AuthorDashboard/ManageResourceTypesGrid.vue": 799,
	"./AuthorDashboard/ManageTagsGrid.vue": 802,
	"./AuthorDashboard/ManageUsers.vue": 803,
	"./AuthorDashboard/SystemEmailsGrid.vue": 804,
	"./AuthorDashboard/components/ActivityLogTab.vue": 471,
	"./AuthorDashboard/components/AddCourse.vue": 458,
	"./AuthorDashboard/components/AddDocumentModal.vue": 466,
	"./AuthorDashboard/components/AddGroupModal.vue": 464,
	"./AuthorDashboard/components/AddLinkModal.vue": 465,
	"./AuthorDashboard/components/AddUser.vue": 66,
	"./AuthorDashboard/components/AuthorUsersCard.vue": 461,
	"./AuthorDashboard/components/EditItemModal.vue": 232,
	"./AuthorDashboard/components/EditUser.vue": 67,
	"./AuthorDashboard/components/FilesManagementTab.vue": 462,
	"./AuthorDashboard/components/LogsAndDataTabs.vue": 473,
	"./AuthorDashboard/components/ManageCourseBase.vue": 35,
	"./AuthorDashboard/components/ManageUsersTabs.vue": 65,
	"./AuthorDashboard/components/MetadataTab.vue": 460,
	"./AuthorDashboard/components/OrganizationTab.vue": 463,
	"./AuthorDashboard/components/SystemConfigurationTabs.vue": 60,
	"./AuthorDashboard/components/WorkflowTab.vue": 467,
	"./AuthorDashboard/components/WorkflowTab/AdminView.vue": 470,
	"./AuthorDashboard/components/WorkflowTab/AuthorView.vue": 468,
	"./AuthorDashboard/components/WorkflowTab/PeerReviewerView.vue": 469,
	"./AuthorDashboard/components/WorkflowTab/ReviewScreen.vue": 89,
	"./Home/CurriculumListing.vue": 808,
	"./ManageAccount/ManageAccount.vue": 818,
	"./ManageAccount/RequestAuthorAccess.vue": 233,
	"./Register/RegisterViews.vue": 821,
	"./Register/components/AddCampusModal.vue": 478,
	"./Register/components/AddInstitutionModal.vue": 477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;